export const replaceValues = (str: string, values: string[]) => {
  return values.reduce((acc: string, value: string, index: number) => {
    return acc.replace(`{${index}}`, value);
  }, str);
};
